// Escape HTML untuk string HTML yang dirakit manual (dokumen cetak, popup & ikon Leaflet).

export const esc = (v: unknown): string =>
  String(v ?? '').replace(
    /[&<>"']/g,
    (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c] as string,
  );
